import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-common-note',
  templateUrl: './common-note.component.html',
  styleUrls: ['./common-note.component.scss'],
})
export class CommonNoteComponent {
  @Input() defaultIcon?: boolean = true;
  @Input() headerText?: string;
  @Input() noteText: string;
}
